// 	GetNumberOftimes: GetNumberOftimes,       //秒差

// 	date: data(new Date),                     //当前日期（如：2020-12-12）

// 	weeks: weeks,                             // 今年的第几周(EN:1,2,3,4,)(ZN:一，二)

// 	fendate: fendate(new Date),               // 当前日期 (date{day: 12,m: 11, y: 2020,z_m:十月} )

// 	timeData: timeData,                       //当前时间,

// 	compareDate:compareDate,                  // 比较时间大小 true第一个大
var GetNumberOfDays = (date1, date2, type) => {
    //获得天数
    if (date1 != '' && date2 != '') {
        //date1 开始日期，date2结束日期
        var a1 = Date.parse(new Date(date1));
        var a2 = Date.parse(new Date(date2));
        var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心 时间戳相减，然后除以天数
        var total = (a2 - a1) / 1000;
        var day = parseInt(total / (24 * 60 * 60)); //计算整数天数
        var afterDay = total - day * 24 * 60 * 60; //取得算出天数后剩余的秒数
        var hour = parseInt(afterDay / (60 * 60)); //计算整数小时数
        var afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60; //取得算出小时数后剩余的秒数
        var min = parseInt(afterHour / 60); //计算整数分
        if (type && !isNaN(day)) {
            return Math.ceil(total / (24 * 60 * 60)) + '天'
        }
        if (!isNaN(day) && !isNaN(min)) {
            return day + '天' + hour + '时' + min + '分';
        }
    }
}
var GetNumberOftimes = (date1, date2) => {
        var s1 = date1.getTime();
        var s2 = date2.getTime();
        var total = (s2 - s1) / 1000;
        var day = parseInt(total / (24 * 60 * 60)); //计算整数天数
        var afterDay = total - day * 24 * 60 * 60; //取得算出天数后剩余的秒数
        var hour = parseInt(afterDay / (60 * 60)); //计算整数小时数
        var afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60; //取得算出小时数后剩余的秒数
        var min = parseInt(afterHour / 60); //计算整数分
        var afterMin = total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60; //取得算出分后剩余的秒数
        if (!isNaN(total)) {
            return total;
        } else {
            uni.showToast({
                icon: "none",
                title: "抱歉计算错误请重新选择"
            })
        }
    }
    // 比较时间大小
var compareDate = (date1, date2) => {
        var oDate1 = new Date(date1);
        var oDate2 = new Date(date2);
        if (oDate1.getTime() > oDate2.getTime()) {
            return true; //第一个大
        } else {
            return false; //第二个大
        }
    }
    // 没有0
var time = () => {
        var now = new Date();
        var hour = now.getHours(); //得到小时
        var minu = now.getMinutes(); //得到分钟
        var sec = now.getSeconds(); //得到秒
        var time = hour + ":" + minu + ":" + sec

        return time
    }
    // 补0 
var timeData = (now) => {
    now ? "" : now = new Date();
    var hour = now.getHours(); //得到小时
    var minu = now.getMinutes(); //得到分钟
    var sec = now.getSeconds(); //得到秒
    var time = (hour <= 9 ? '0' + hour : hour) + ":" + (minu <= 9 ? '0' + minu : minu) + ":" + (sec <= 9 ? '0' + sec :
        sec)
    return time
}


var data = (dd8) => {
    var dd8 = dd8 ? dd8 : new Date();
    var y = dd8.getFullYear()
    var m = dd8.getMonth() + 1 < 10 ? '0' + (dd8.getMonth() + 1) : dd8.getMonth() + 1 // 获取当前月份的日期，不足10补0
    var d = dd8.getDate() < 10 ? '0' + dd8.getDate() : dd8.getDate()
    return y + '-' + m + '-' + d
}


var weeks = (language, date, RDate) => {
    var weeksArr = ['日', '一', '二', '三', '四', '五', '六']; //周日做为下周的开始计算
    var d1 = date;
    var d2 = RDate;
    d2.setMonth(0);
    d2.setDate(1);
    var rq = d1 - d2;
    var s1 = Math.ceil(rq / (24 * 60 * 60 * 1000));
    var s2 = Math.ceil(s1 / 7);
    if (language == "ZN") {
        return weeksArr[s2]
    } else {
        return s2
    }

}

var fendate = (dd8) => {
    // var dd8 = new Date();
    var y = dd8.getFullYear()
    var m = dd8.getMonth() + 1 < 10 ? '0' + (dd8.getMonth() + 1) : dd8.getMonth() + 1 // 获取当前月份的日期，不足10补0
    var d = dd8.getDate() < 10 ? '0' + dd8.getDate() : dd8.getDate()
    var date = {
        day: d,
        m: m,
        y: y,
        z_m: number2Chinese(y + '-' + m + '-' + d)
    }
    return date
}

var number2Chinese = (str) => {
    var chinese = [' ', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
    var numStr = str.replace(/[^0-9]+/g, '');
    var year = chinese[numStr[0]] + chinese[numStr[1]] + chinese[numStr[2]] + chinese[numStr[3]];
    var month = numStr[4] === '0' ? chinese[numStr[5]] : chinese[10] + chinese[numStr[5]];
    var day = '';
    if (numStr[6] === '0') {
        day = chinese[numStr[7]];
    } else if (numStr[6] === '1') {
        if (numStr[7] === '0') {
            day = chinese[10];
        } else {
            day = chinese[10] + chinese[numStr[7]];
        }
    } else if (numStr[6] === '2' || numStr[6] === '3') {
        if (numStr[7] === '0') {
            day = chinese[numStr[6]] + chinese[10];
        } else {
            day = chinese[numStr[6]] + chinese[10] + chinese[numStr[7]];
        }
    }
    return month + '月';
}


module.exports = {
    GetNumberOfDays: GetNumberOfDays, //日期差

    GetNumberOftimes: GetNumberOftimes, //秒差

    date: data(new Date), //当前日期（如：2020-12-12）

    weeks: weeks, // 今年的第几周(EN:1,2,3,4,)(ZN:一，二)

    fendate: fendate(new Date), // 当前日期 (date{day: 12,m: 11, y: 2020,z_m:十月} )

    timeData: timeData, //当前时间,
    compareDate: compareDate, // 比较时间大小 true第一个大
}